module.exports = __webpack_public_path__ + "img/BGviola.aa77d925.png";